import React from 'react';
import { List } from '@smarterservices/smarter-ui';
import { BlockComponentProps, BulletListBlock as BulletListBlockType, ListItemBlock } from '../../types';
import { formatText } from '../../utils/textFormatter';

/**
 * BulletListBlock component renders an unordered (bullet) list
 * 
 * @param {BlockComponentProps<BulletListBlockType>} props - Component props
 * @returns {React.ReactElement} Rendered bullet list
 */
export const BulletListBlock = ({ block }: BlockComponentProps<BulletListBlockType>) => {
  if (!block.items || !Array.isArray(block.items) || block.items.length === 0) {
    return null;
  }
  
  return (
    <List as="ul" margin={block.margin || "none"}>
      {block.items.map((item: ListItemBlock, index: number) => (
        <List.Item 
          key={`bullet-item-${index}`}
          margin="x-small 0"
        >
          {formatText(item.text, block.replacements)}
        </List.Item>
      ))}
    </List>
  );
};

export default BulletListBlock;
